import React, { PureComponent } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ReferenceLine,
  ResponsiveContainer,
} from "recharts";
import Brightness1Icon from "@material-ui/icons/Brightness1";
// import { ageCheck } from "../../../../../utils/calculate";

const data = [
  {
    name: "0~4세",
    남성: 0,
    여성: 0.1,
  },
  {
    name: "5~9세",
    남성: 0,
    여성: 0,
  },
  {
    name: "10~14세",
    남성: 0,
    여성: 0,
  },
  {
    name: "15~19세",
    남성: 0.1,
    여성: 0.1,
  },
  {
    name: "20~24세",
    남성: 0.2,
    여성: 0.4,
  },
  {
    name: "25~29세",
    남성: 0.9,
    여성: 0.6,
  },
  {
    name: "30~34세",
    남성: 1.2,
    여성: 1.9,
  },
  {
    name: "35~39세",
    남성: 4.2,
    여성: 3.7,
  },
  {
    name: "40~44세",
    남성: 7.4,
    여성: 8.0,
  },
  {
    name: "45~49세",
    남성: 15.7,
    여성: 14.8,
  },
  {
    name: "50~54세",
    남성: 36.6,
    여성: 28.0,
  },
  {
    name: "55~59세",
    남성: 71.3,
    여성: 44.9,
  },
  {
    name: "60~64세",
    남성: 154.3,
    여성: 73.4,
  },
  {
    name: "65~69세",
    남성: 288.7,
    여성: 89.7,
  },
  {
    name: "70~74세",
    남성: 410.1,
    여성: 122.6,
  },
  {
    name: "75~79세",
    남성: 581.8,
    여성: 151.8,
  },
  {
    name: "80~84세",
    남성: 669.5,
    여성: 171.5,
  },
  {
    name: "85세이상",
    남성: 641.5,
    여성: 191.5,
  },
];

const CustomTooltip = ({ active, payload, label }) => {
  if (payload === null || payload === undefined) return null;
  if (active)
    return (
      // <ToltipCustom>
      <div
        style={{
          background: "#fff",
          borderRadius: 4,
          padding: 12,
          border: "1px solid rgb(47 55 61 / 25%)",
          lineHeight: 1.5,
        }}
      >
        <div style={{ color: "#333", fontWeight: 500 }}>
          <div>{label}</div>
          <div>폐암 발생 빈도(10만 명당)</div>
        </div>
        <div className="desc-tooltip">
          <span className="value-tooltip">
            <Brightness1Icon style={{ fontSize: 10, color: "#5d2cff" }} />
            &nbsp; 남성 : {payload[0].value}명
          </span>
        </div>
        <div className="desc-tooltip">
          <span className="value-tooltip">
            <Brightness1Icon style={{ fontSize: 10, color: "#ff9300" }} />
            &nbsp; 여성 : {payload[1].value}명
          </span>
        </div>
      </div>
    );
  return null;
};
// const ageChart = [
//   5,
//   10,
//   15,
//   20,
//   25,
//   30,
//   35,
//   40,
//   45,
//   50,
//   55,
//   60,
//   65,
//   70,
//   75,
//   80,
//   85,
//   9999999,
// ];
const ageChecker = (age) => {
  let title = "";
  if (0 <= age && age < 5) {
    title = data[0].name;
  } else if (5 <= age && age < 10) {
    title = data[1].name;
  } else if (10 <= age && age < 15) {
    title = data[2].name;
  } else if (15 <= age && age < 20) {
    title = data[3].name;
  } else if (20 <= age && age < 25) {
    title = data[4].name;
  } else if (25 <= age && age < 30) {
    title = data[5].name;
  } else if (30 <= age && age < 35) {
    title = data[6].name;
  } else if (35 <= age && age < 40) {
    title = data[7].name;
  } else if (40 <= age && age < 45) {
    title = data[8].name;
  } else if (45 <= age && age < 50) {
    title = data[9].name;
  } else if (50 <= age && age < 55) {
    title = data[10].name;
  } else if (55 <= age && age < 60) {
    title = data[11].name;
  } else if (60 <= age && age < 65) {
    title = data[12].name;
  } else if (70 <= age && age < 70) {
    title = data[13].name;
  } else if (75 <= age && age < 75) {
    title = data[14].name;
  } else if (75 <= age && age < 80) {
    title = data[15].name;
  } else if (80 <= age && age < 85) {
    title = data[16].name;
  } else {
    title = data[17].name;
  }
  return title;
};
const CustomLabel = (props) => {
  return (
    <g>
      <rect
        x={props.viewBox.x - 50}
        y={props.viewBox.y}
        fill="#ffffff"
        width={100}
        height={30}
      />
      <text
        x={props.viewBox.x - 65}
        y={props.viewBox.y}
        fill="#115bab"
        dy={20}
        dx={30}
      >
        {props.value}
      </text>
    </g>
  );
};
export default class LungChart extends PureComponent {
  static demoUrl =
    "https://codesandbox.io/s/line-chart-width-xaxis-padding-sujqi";

  render() {
    return (
      <ResponsiveContainer width="100%">
        <LineChart
          width={492}
          height={220}
          data={data}
          margin={{ top: 0, left: 0, right: 80, bottom: 0 }}
        >
          {/* <CartesianGrid strokeDasharray="3 3" /> */}
          <XAxis
            dataKey="name"
            label={{
              value: "연령대",
              position: "right",
              offset: 30,
              fontSize: 16,
            }}
          />
          <YAxis
            fontSize="12"
            // label={{
            //   value: "나이",
            //   position: "top",
            //   offset: -2-,
            //   fontSize: 12,
            // }}
          />
          <Tooltip content={<CustomTooltip />} animationDuration={1} />
          {/* <Legend /> */}
          <ReferenceLine
            x={ageChecker(this.props.age.value)}
            stroke="#115bab"
            strokeWidth={4}
            style={{ color: "#115bab" }}
            // label="내 연령대"
            // label={{
            //   position: "insideTopRight",
            //   value: <>내연령대</>,
            //   fill: "#115bab",
            //   fontSize: 14,
            // }}
            label={
              <CustomLabel
                // position="top"
                value="나의 연령대"
                fill="#115bab"
                fontSize={14}
              />
            }
          />
          <Line
            type="monotone"
            dataKey="남성"
            stroke="#5d2cff"
            dot={false}
            activeDot={{ r: 4 }}
          />
          <Line type="monotone" dataKey="여성" dot={false} stroke="#ff9300" />
        </LineChart>
      </ResponsiveContainer>
    );
  }
}
